import {
  AfterViewInit,
  Component,
  ElementRef,
  HostListener,
  Input,
  OnDestroy,
  OnInit,
  Renderer2,
  TemplateRef,
  ViewChild,
} from "@angular/core";
import { DomSanitizer, SafeResourceUrl } from "@angular/platform-browser";
import { NavigationEnd, Router } from "@angular/router";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { BsModalRef, BsModalService } from "ngx-bootstrap/modal";
import { ToastrService } from "ngx-toastr";
import { ProdutoVM } from "src/app/api/model/produto/produtoVM";
import { ProdutoService } from "src/app/api/module/portal/services/produto/produto.service";
import { AutoSliderItem } from "src/app/api/module/portal/model/auto-slider";
import { AutoSliderImagesService } from "src/app/api/module/portal/services/auto-slider-images.service";
import { Subject, filter, finalize, take, takeUntil } from "rxjs";
import { ContaService } from "src/app/api/module/erp/services/auth/conta.service";
import { ScrollService } from "src/app/components/helper/service/scroll/scroll.service";
import { CompartilharDadosEntreComponentsService } from "src/app/api/module/erp/shared/services/compartilhar-dados-entre-components.service";
import { ErrorLoggingService } from "src/app/api/module/erp/shared/services/error-logs/error-logging.service";
import { SpinnerService } from "src/app/api/module/erp/shared/services/spinner-service.service";

@Component({
  selector: "app-geia-portal",
  templateUrl: "./geia-portal.component.html",
  styleUrls: ["./geia-portal.component.scss"],
})
export class GeiaPortalComponent implements OnInit, AfterViewInit, OnDestroy {
  private destroy$ = new Subject<void>();

  listaProdutos: ProdutoVM[] = [];
  dadosOperadoraDM: any[] = [];

  listaTemMenorValorOdonto!: ProdutoVM[];
  menorProduto!: ProdutoVM;
  listaTemMenorValorSaude: any;
  menorValorOdonto!: ProdutoVM;
  menorValorSaude!: ProdutoVM;
  valorAntesDoPontoSaude: string = "";
  valorDepoisDoPontoSaude: string = "";
  valorAntesDoPontoOdonto: string = "";
  valorDepoisDoPontoOdonto: string = "";
  modalRef?: BsModalRef;
  ideOperadoraUrl!: string;
  urlIframe!: SafeResourceUrl;
  listItensBanner: [] = [];
  public selected = false;
  public sections = 3;
  public scroll: any = 0;
  sliderItemsSaude: AutoSliderItem[] = [];
  sliderItemsOdonto: AutoSliderItem[] = [];
  mostrarChat!: boolean;
  currentSection: string = 'saude';
  ideOperadora: string = "";
  nomeOperadora: any = "";

  constructor(
    private router: Router,
    private toastr: ToastrService,
    private _produtoService: ProdutoService,
    private _spinnerService: SpinnerService,
    private _errorLoggingService: ErrorLoggingService,
    private renderer: Renderer2,
    public activeModal: NgbActiveModal,
    private modalService: BsModalService,
    private sanitizer: DomSanitizer,
    private autoSliderImagesService: AutoSliderImagesService,
    private contaService: ContaService,
    private _scrollService: ScrollService,
    private _compartilharDadosEntreComponentsService: CompartilharDadosEntreComponentsService
  ) { }

  ngAfterViewInit() {
  }

  ngOnInit(): void {
    this.verificarUrlInicial();
    this.onLogout();
    this.buscarDados();
    this.loadImagesSaude();
    this.loadImagesOdonto();
    this.atualizarItemClicadoMenu();
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  iniciarSpinner(mensagem: string = 'Carregando...'): void {
    this._spinnerService.show(mensagem);
  }

  pararSpinner(): void {
    this._spinnerService.hide();
  }

  onLogout() {
    this.contaService.onlogOut();
  }

  goSectionInit(sectionId: any) {
    sectionId.style.scrollMarginTop = `140px`;
    sectionId.scrollIntoView({ behavior: 'smooth', block: 'start' });
    this.atualizarItemClicadoMenu();
  }

  verificarUrlInicial() {
    const currentUrl = this.router.url;
    if (currentUrl.includes("odonto")) {
      setTimeout(() => {
        this.currentSection = "odonto";
        const odontoSection = document.getElementById("odonto");
        if (odontoSection) {
          this.goSectionInit(odontoSection);
        }
      }, 100);
    } else if (currentUrl.includes("saude")) {
      this.currentSection = "saude";
      setTimeout(() => {
        const saudeSection = document.getElementById("saude");
        if (saudeSection) {
          this.goSectionInit(saudeSection);
        }
      }, 100);
    } else if (currentUrl.includes("seguro")) {
      this.currentSection = "seguro";
      setTimeout(() => {
        const seguroSection = document.getElementById("seguro");
        if (seguroSection) {
          this.goSectionInit(seguroSection);
        }
      }, 100);
    }
  }

  loadImagesSaude() {
    this.autoSliderImagesService
      .getImagesSaude()
      .pipe(takeUntil(this.destroy$))
      .subscribe((images) => {
        this.sliderItemsSaude = images.concat(images, images);
      });
  }

  loadImagesOdonto() {
    this.autoSliderImagesService
      .getImagesOdonto()
      .pipe(takeUntil(this.destroy$))
      .subscribe((images) => {
        this.sliderItemsOdonto = images.concat(images, images);
      });
  }

  buscarDados() {
    this.iniciarSpinner();
    this._produtoService
      .buscarDadosDaApi()
      .pipe(
        takeUntil(this.destroy$),
        finalize(() => {
          this.pararSpinner();
        }),
      )
      .subscribe({
        next: (data) => {
          const lista = data?.List || [];
          this.listaProdutos = this.agruparProdutosPorTipo(lista);
          this.menorValorOdonto = this.encontrarMenorValorPorTipo(
            lista, "Odonto"
          );
          this.menorValorSaude = this.encontrarMenorValorPorTipo(
            lista, "Saúde"
          );

          this.separarValor();
        },
        error: (error) => {
          this.toastr.error('Erro ao carregar produtos do portal.');
          this._errorLoggingService.logError('Erro ao buscar dados dos produtos no Portal', error, {
            contexto: 'GeiaPortalComponent.buscarDados',
            data: {
              url: this.router.url,
            },
          });
        },
      });
  }

  encontrarMenorValorPorTipo(produtos: any[], tipo: string): ProdutoVM {
    if (!produtos || produtos.length === 0) {
      return null as any;
    }
    const produtosFiltrados = produtos.filter(
      (produto) => produto?.TipoProduto === tipo
    );
    if (tipo == "Saúde") {
      const novaListaSaude = produtosFiltrados.filter(
        (x) => x?.NomeOperadora != "SÃO FRANCISCO VIDA".trim()
      );
      return this.encontrarMenorValor(novaListaSaude);
    }

    return this.encontrarMenorValor(produtosFiltrados);
  }

  separarValor(): void {
    // Saúde
    if (this.menorValorSaude?.Valor != null) {
      const saude = Number(this.menorValorSaude.Valor).toFixed(2).split(".");
      this.valorAntesDoPontoSaude = saude[0] || "0";
      this.valorDepoisDoPontoSaude = saude[1] || "00";
    } else {
      this.valorAntesDoPontoSaude = "0";
      this.valorDepoisDoPontoSaude = "00";
    }

    // Odonto
    if (this.menorValorOdonto?.Valor != null) {
      const odonto = Number(this.menorValorOdonto.Valor).toFixed(2).split(".");
      this.valorAntesDoPontoOdonto = odonto[0] || "0";
      this.valorDepoisDoPontoOdonto = odonto[1] || "00";
    } else {
      this.valorAntesDoPontoOdonto = "0";
      this.valorDepoisDoPontoOdonto = "00";
    }
  }

  formatarValor(valor: number): string {
    return valor ? valor.toString().replace(".", ",") : "0,00";
  }

  encontrarMenorValor(produtos: any[]): ProdutoVM {
    if (!produtos || produtos.length === 0) {
      return null as any;
    }
    return produtos.reduce((minProduto, produto) => {
      if (!minProduto || (produto?.Valor != null && produto.Valor < minProduto.Valor)) {
        return new ProdutoVM(
          produto.IdOperadora,
          produto.NomeOperadora,
          produto.Ans,
          produto.TipoProduto,
          produto.NomeProduto,
          produto.De,
          produto.Ate,
          produto.Valor,
          produto.Validade
        );
      }
      return minProduto;
    }, null);
  }

  agruparProdutosPorTipo(produtos: any[]): ProdutoVM[] {
    const grupos: { [key: string]: ProdutoVM } = {};

    (produtos || []).forEach((produto) => {
      const tipoProduto = produto?.TipoProduto;
      const tipoOperadora = tipoProduto + "-" + produto?.NomeOperadora;

      if (
        !grupos[tipoOperadora] ||
        (produto?.Valor != null && produto.Valor < grupos[tipoOperadora].Valor)
      ) {
        grupos[tipoOperadora] = new ProdutoVM(
          produto.IdOperadora,
          produto.NomeOperadora,
          produto.Ans,
          produto.TipoProduto,
          produto.NomeProduto,
          produto.De,
          produto.Ate,
          produto.Valor,
          produto.Validade
        );
      }
    });

    return Object.values(grupos);
  }
  atualizarItemClicadoMenu() {
    this._scrollService.sectionId$.subscribe(sectionId => {
      this.currentSection = sectionId;
    });
  }
  navigateToSection(sectionId: string, isMobile?: string): void {
    const marginTop = 114;
    this.currentSection = ""
    this.currentSection = sectionId; // Atualizar imediatamente
    this._scrollService.navigateToSection(sectionId, 'portal', "", marginTop);
  }

  simularPorOperadora(template: TemplateRef<any>, idOperadora?: string, nomeOperadora?: any, tipoPlano: string = 'saude') {
    // Fallback se não veio id direto pelo menor valor
    if (!idOperadora && this.listaProdutos?.length) {
      const tipo = tipoPlano.toLowerCase().includes('odonto') ? 'Odonto' : 'Saúde';
      const fallback = this.listaProdutos.find(p => p.TipoProduto === tipo);
      if (fallback) {
        idOperadora = fallback.IdOperadora;
        nomeOperadora = fallback.NomeOperadora;
      }
    }

    let dadosOperadora: any = {
      idOperadora: idOperadora,
      nomeOperadora: nomeOperadora,
      origem: "Portal",
      tipo: tipoPlano
    };

    this.compartilharDados(dadosOperadora);

    if (idOperadora) {
      window.open(`#/portal/cotacao/${tipoPlano}/${idOperadora}`, '_self');
    } else {
      window.open(`#/portal/cotacao/${tipoPlano}`, '_self');
    }
  }
  decline(): void {
    this.modalRef?.hide();
  }
  private compartilharDados(data: any) {

    this.dadosOperadoraDM = [];
    this.dadosOperadoraDM.push({
      data: data
    });

    this._compartilharDadosEntreComponentsService && this._compartilharDadosEntreComponentsService.enviarDadosParaOutroComponent(
      this.dadosOperadoraDM
    );
  }
}
